/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Platform_InstagramInputs */

const cs_social_export_platform_instagram = /** @type {(inputs: Social_Export_Platform_InstagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

const en_social_export_platform_instagram = /** @type {(inputs: Social_Export_Platform_InstagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

/**
* | output |
* | --- |
* | "Instagram" |
*
* @param {Social_Export_Platform_InstagramInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_platform_instagram = /** @type {((inputs?: Social_Export_Platform_InstagramInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Platform_InstagramInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_platform_instagram(inputs)
	return cs_social_export_platform_instagram(inputs)
});